"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const LoaderCell = (fieldRenderSpinner) => {
    const funcReturn = (defaultRender, { dataItem, field }) => {
        if (dataItem.isLoadingItem) {
            if (typeof fieldRenderSpinner === 'string') {
                if (field === fieldRenderSpinner) {
                    return ((0, jsx_runtime_1.jsx)("td", { children: (0, jsx_runtime_1.jsx)("span", { className: 'k-icon k-i-loading' }) }));
                }
                return defaultRender;
            }
            if (fieldRenderSpinner.includes(field || 'abcdefghijklmnopqrstuvwxyz')) {
                return ((0, jsx_runtime_1.jsx)("td", { children: (0, jsx_runtime_1.jsx)("span", { className: 'k-icon k-i-loading' }) }));
            }
        }
        return defaultRender;
    };
    return funcReturn;
};
exports.default = LoaderCell;
